import styled from 'styled-components'

import { ContentPadded } from 'components/Layout'

export const BottomDisclaimer = styled(ContentPadded)`
	padding: 0 22px;
`
